import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";

interface DateSelectionModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: (selectedDate: Date | null) => void;
}

const DateSelectionModal: React.FC<DateSelectionModalProps> = ({
	isOpen,
	onClose,
	onSubmit,
}) => {
	const [selectedDate, setSelectedDate] = useState<Date | null>(null);

	const handleSubmit = () => {
		onSubmit(selectedDate);
		onClose();
	};

	return (
		<Dialog
			open={isOpen}
			onClose={onClose}
			className="fixed inset-0 z-10 overflow-y-auto"
		>
			<div className="flex items-center justify-center min-h-screen p-4 bg-gray-900 bg-opacity-25">
				<DialogPanel className="w-full max-w-md rounded bg-white p-6 shadow-lg">
					<DialogTitle className="mb-4 text-xl font-semibold">
						Selecione uma data
					</DialogTitle>
					<DatePicker
						selected={selectedDate}
						onChange={(date: Date | null) => setSelectedDate(date)}
						dateFormat="dd/MM/yyyy"
						className="w-full rounded border p-2"
					/>
					<div className="mt-4 flex justify-end gap-2">
						<button
							onClick={onClose}
							className="rounded bg-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-400"
						>
							Cancelar
						</button>
						<button
							onClick={handleSubmit}
							className="rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
						>
							Aplicar
						</button>
					</div>
				</DialogPanel>
			</div>
		</Dialog>
	);
};

export default DateSelectionModal;
